import { createContext } from 'react';

const LocationContext = createContext({
    titleIndex: 0,
    subtitleIndex: 0,
    paragraphIndex: 0,
    elementIndex: 0
})

export default LocationContext;